import { TableTemplate } from 'types/tableTemplate';

export const reportSurgerieTableTemplate: TableTemplate[] = [
  {
    id: 'action',
    description: 'Ações',
    originalId: 'action',
    width: 60,
  },
  {
    id: 'id',
    description: 'ID',
    originalId: 'id',
    width: 50,
  },
  {
    id: 'formattedCreatedAt',
    description: 'Criado em',
    originalId: 'created_at',
    width: 100,
  },
  {
    id: 'formattedClosedAt',
    description: 'Fechado em',
    originalId: 'closed_at',
    width: 100,
  },
  {
    id: 'patientProcedure',
    description: 'Paciente / Procedimento',
    originalId: 'patientProcedure',
    width: 250,
  },
  {
    id: 'formattedDoctorName',
    description: 'Médico',
    originalId: 'formattedDoctorName',
    width: 200,
  },
  {
    id: 'formattedHospitalName',
    description: 'Hospital',
    originalId: 'formattedHospitalName',
    width: 200,
  },
  {
    id: 'formattedTotalValue',
    description: 'Valor Total',
    originalId: 'value_total',
    width: 120,
    dataType: 'number',
  },
  {
    id: 'formattedValueEntry',
    description: 'Valor Entrada',
    originalId: 'value_entry',
    width: 120,
    dataType: 'number',
  },
  {
    id: 'formattedValuePaid',
    description: 'Valor Pago',
    originalId: 'value_paid',
    width: 120,
    dataType: 'number',
  },
  {
    id: 'formattedStatus',
    description: 'Status',
    originalId: 'status',
    width: 120,
  },
  {
    id: 'closed_by',
    description: 'Fechado por',
    originalId: 'closed_by',
    width: 150,
  },
];
